"use strict";

define('evisions/helper/event',['underscore'], function (_) {
  var EVIHelperEvent = _.extend({
    bindAll: function bindAll(obj) {
      var i = 0,
        keys = [],
        fn = null,
        k;
      for (k in obj) {
        keys.push(k);
      }
      if (!obj || !obj.constructor) {
        return obj;
      }
      for (i = 0; i < keys.length; ++i) {
        fn = obj[keys[i]];
        if (_.isFunction(fn) && keys[i] !== 'constructor' && _.contains(obj.constructor.prototype, fn)) {
          obj[keys[i]] = _.bind(fn, obj);
        }
      }
      return obj;
    },
    fire: function fire(event, data) {
      var d = $(document);
      d.trigger.apply(d, arguments);
    },
    observe: function observe(event, callback) {
      var doc = $(document).bind(event, callback);
      return {
        remove: function remove() {
          doc.unbind(event, callback);
        }
      };
    }
  });
  return EVIHelperEvent;
});

